$.fn.paginate = function(options) {
    options = $.extend({
        startPage: 1,
        innerReceiver: '.content-loader',
        prevButton: '.paginate-left',
        nextButton: '.paginate-right',
        updateButton: '.paginate-update',
        onChangePage: $.noop
    }, options);

    var currentPaginate;

    function isLoading() {
        return currentPaginate.data('disabled');
    }

    function startLoading() {
        currentPaginate.data('disabled', true);
    }

    function stopLoading() {
        currentPaginate.data('disabled', false);
    }

    function changePage(e, predefinedPage) {
        predefinedPage = (typeof predefinedPage === 'undefined') ? false : predefinedPage;

        if (!isLoading()) {
            startLoading();

            var outerReceiver = $(currentPaginate.data('receiver'));
            var innerReceiver;

            if (outerReceiver.find(options.innerReceiver).length == 0) {
                innerReceiver = outerReceiver;
            } else {
                innerReceiver = outerReceiver.find(options.innerReceiver);
            }

            var direction = e.data.direction;

            var currentPage   = currentPaginate.data('currentPage') || options.startPage;
            var newPage = (predefinedPage === false)  ? ((direction == 'prev' || direction == 'up') ? currentPage - 1 : currentPage + 1) : predefinedPage;

            var ajaxUrl = "/a/" + currentPaginate.data('paginate') + "/paginate";
            var ajaxInfos = currentPaginate.data();

            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    'page': newPage,
                    'infos': ajaxInfos
                },
                beforeSend: function() {
                    outerReceiver.animate({
                        'opacity': 0.5
                    }, 'fast');
                }
            }).done(function(data) {
                stopLoading();

                outerReceiver.stop(true, true).animate({'opacity': 1}, 'fast', function() {
                    var effectDirectionOne = (direction == 'prev') ? 'right' : 'left';
                    var effectDirectionTwo = (direction == 'prev') ? 'left' : 'right';

                    if (direction == 'prev') {
                        effectDirectionOne = 'right';
                        effectDirectionTwo = 'left';
                    } else if (direction == 'next') {
                        effectDirectionOne = 'left';
                        effectDirectionTwo = 'right';
                    } else if (direction == 'up') {
                        effectDirectionOne = 'down';
                        effectDirectionTwo = 'up';
                    } else if (direction == 'down') {
                        effectDirectionOne = 'up';
                        effectDirectionTwo = 'down';
                    }

                    innerReceiver.hide('slide', {'direction': effectDirectionOne}, 'fast', function() {
                        innerReceiver.html(data.html).show('slide', {'direction': effectDirectionTwo}, function() {
                            options.onChangePage.call(null, innerReceiver, event);
                        });
                    });
                });

                currentPaginate.data('currentPage', newPage);

                if (data.moreToLoadPrev) {
                    currentPaginate.find(options.prevButton).removeClass('disabled');
                } else {
                    currentPaginate.find(options.prevButton).addClass('disabled');
                }

                if (data.moreToLoadNext) {
                    currentPaginate.find(options.nextButton).removeClass('disabled');
                } else {
                    currentPaginate.find(options.nextButton).addClass('disabled');
                }
            });
        }
    }

    function update(e) {
        changePage(e, 1);
    }

    this.each(function(index, value) {
        currentPaginate = $(this);

        currentPaginate.on('click', options.prevButton + ':not(.disabled):not(.paginate-dir-up):not(.paginate-dir-down)', {'direction': 'prev'}, changePage);
        currentPaginate.on('click', options.nextButton + ':not(.disabled):not(.paginate-dir-up):not(.paginate-dir-down)', {'direction': 'next'}, changePage);

        currentPaginate.on('click', options.prevButton + ':not(.disabled).paginate-dir-up', {'direction': 'up'}, changePage);
        currentPaginate.on('click', options.nextButton + ':not(.disabled).paginate-dir-down', {'direction': 'down'}, changePage);

        currentPaginate.on('click', options.updateButton + ':not(.disabled)', {'direction': 'up'}, update);
    });

    return this;
};
